import React, { Component } from 'react';

import classes from './EmailRegisterInner.module.css';
import StepOne from './Steps/StepOne/StepOne';
import StepTwo from './Steps/StepTwo/StepTwo';
import StepThree from './Steps/StepThree/StepThree';
import StepFour from './Steps/StepFour/StepFour';
import StepFive from './Steps/StepFive/StepFive';

export default class EmailRegisterInner extends Component {
  state = {
    hideHeader: false,
  };

  onFocus = () => {
    if (!this.props.isLandscape) {
      this.setState({ hideHeader: true });
    }
  };

  onBlur = () => {
    if (!this.props.isLandscape) {
      this.setState({ hideHeader: false });
    }
  };

  render() {
    // console.log('EMAIL REGISTER INNER RENDER:', this.props, this.state);
    const { step } = this.props;
    let activeStep;

    if (step === 2) {
      activeStep = (
        <StepTwo
          isLandscape={this.props.isLandscape}
          goToStep={this.props.goToStep}
          setLocation={this.props.setLocation}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          hideHeader={this.state.hideHeader}
          searchLocation={this.props.searchLocation}
          nbsApiSearchLocation={this.props.nbsApiSearchLocation}
          location={this.props.location}
        />
      );
    } else if (step === 3) {
      activeStep = (
        <StepThree
          isLandscape={this.props.isLandscape}
          goToStep={this.props.goToStep}
          age={this.props.age}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          hideHeader={this.state.hideHeader}
          minAge={this.props.minAge}
          maxAge={this.props.maxAge}
          setAge={this.props.setAge}
        />
      );
    } else if (step === 4) {
      activeStep = (
        <StepFour
          isLandscape={this.props.isLandscape}
          username={this.props.username}
          setUsername={this.props.setUsername}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          hideHeader={this.state.hideHeader}
          checkUsername={this.props.checkUsername}
          nbsApiCheckUsername={this.props.nbsApiCheckUsername}
          goToStep={this.props.goToStep}
        />
      );
    } else if (step === 5) {
      activeStep = (
        <StepFive
          email={this.props.email}
          password={this.props.password}
          country={this.props.country}
          setEmail={this.props.setEmail}
          setPassword={this.props.setPassword}
          isLandscape={this.props.isLandscape}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          hideHeader={this.state.hideHeader}
          goToStep={this.props.goToStep}
          emailRegister={this.props.emailRegister}
          emailLogin={this.props.emailLogin}
          createAccount={this.props.createAccount}
          transCoregLookup={this.props.transCoregLookup}
          getTransCoreg={this.props.getTransCoreg}
          isTransCoregOfferChecked={this.props.isTransCoregOfferChecked}
          toggleTransCoregOffer={this.props.toggleTransCoregOffer}
          getConfig={this.props.getConfig}
          transCoregText={this.props.transCoregText}
          showTransCoregCheckbox={this.props.showTransCoregCheckbox}
          setTransCoreg={this.props.setTransCoreg}
          toggleMinHeight={this.props.toggleMinHeight}
        />
      );
    } else {
      activeStep = (
        <StepOne
          areGendersPreselectedFromUrlData={
            this.props.areGendersPreselectedFromUrlData
          }
          genderApiConfigDataLodaded={this.props.genderApiConfigDataLodaded}
          // gender={this.props.gender}
          // seeking={this.props.seeking}

          gender={this.props.gender || 1}
          seeking={this.props.seeking || 2}
          genderAndSeekingSelectedValue={
            this.props.genderAndSeekingSelectedValue
          }
          goToStep={this.props.goToStep}
          setGenderAndSeeking={this.props.setGenderAndSeeking}
          isLandscape={this.props.isLandscape}
          getConfig={this.props.getConfig}
        />
      );
    }

    return <div className={classes.EmailRegisterInner}>{activeStep}</div>;
  }
}
